import {createAppProperties} from "./LocationUtil";
import {AppDispatch} from "../AppStore";
import {AppState} from "../AppState";
import {LocationProperties} from "../util/LocationParser";
import {locationManager} from "../BootStrap";
import {ensurePgpKeysLoaded} from "../util/PGPUtil";
import {isPgpKeyContent} from "../domain/ItemContent";
import {ItemActions} from "../actions/ItemActions";
import {getItemContent, NoItemContent} from "../state/ItemState";
import {getKeyHexId} from "../domain/PgpKey";

export interface PgpKeysLocationProperties {
    kH?: string;
}

export const PgpKeysLocationPropertyNames = createAppProperties<PgpKeysLocationProperties>("kH");

export class PgpKeysLocation {

    static handleLocationChange(dispatch: AppDispatch, getState: () => AppState, newLocation: LocationProperties): void {

        console.log("PGP key view");

        const {accountsState, itemState} = getState();

        ensurePgpKeysLoaded(dispatch, accountsState)
            .catch(e => console.error("Unable to load all PGP keys", e));

        const content = getItemContent(itemState);
        if (!isPgpKeyContent(content) || getKeyHexId(content.key) !== newLocation.kH) {
            const keyIdString = newLocation.kH;

            const pgpKey = accountsState.secretKeys.find(k => k.keyHexId === keyIdString)
                || accountsState.pgpKeys.find(k => k.keyHexId === keyIdString)
                || (keyIdString ? {unknownKeyHexId: keyIdString} : NoItemContent);

            dispatch(ItemActions.showItemContent(pgpKey));
        }
    }

    static selectPgpKey(keyIdString: string | undefined) {
        locationManager.updateWindowLocation("pgpkeys", {kH: keyIdString});
    }
}
